import getLocale from './getLocale';

export default function NumberFormat(num: number) {
    let number = num;
    if (typeof num !== 'number') {
        number = Number(number);
    }
    if (Number.isNaN(number)) {
        return 0;
    }

    return number.toLocaleString(getLocale(), {
        maximumFractionDigits: 2,
    });
}
